// eslint-disable-next-line import/prefer-default-export
export enum FinishedStepType {
  CONNECTED_FIRST_PACKAGE = 'connected_first_package',
  CONNECTED_LAST_PACKAGE = 'connected_last_package',
  SET_UP_CONNECTION_SETTINGS = 'set_up_the_connection_settings',
  FINALIZE_CONNECTION_SETTINGS = 'finalize_the_connection_settings',
  RUN_CONNECTION = 'run_the_connection',
}
